/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Tipi utente. Tipi previsti:   -*ADMIN*  -*OP_COMUNE*  -*OP_SCUOLA*  -*OP_CENTRO_COTTURA*  -*GENITORE*  -*CITTADINO*
 */
export type UserType = 'ADMIN' | 'OP_COMUNE' | 'OP_SCUOLA' | 'OP_CENTRO_COTTURA' | 'GENITORE' | 'CITTADINO';

export const UserType = {
    ADMIN: 'ADMIN' as UserType,
    OPCOMUNE: 'OP_COMUNE' as UserType,
    OPSCUOLA: 'OP_SCUOLA' as UserType,
    OPCENTROCOTTURA: 'OP_CENTRO_COTTURA' as UserType,
    GENITORE: 'GENITORE' as UserType,
    CITTADINO: 'CITTADINO' as UserType
};